module.exports = __webpack_public_path__ + "assets/financial.c105086d.svg";